import lazyLoadView from "@router-utils/lazyload-view";
import routeError from "@router-utils/route-error";
import store from '@store'
import { getDefaultCategory, getDefaultStore } from "@utils/ipetbooking-get-default";

export default [
  // ===
  // 首頁
  // ===
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/Home/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          if(store.getters['auth/isLoggedIn']) {
            await store.dispatch('auth/fetchMemberPetList', {
              useCached: true
            });
          }

          const [
            currentService
          ] = await Promise.all([
            store.dispatch('merchant/fetchReservationPrice', {
              storeAlias: getDefaultStore(routeTo.query.serviceStore),
              categoryAlias: getDefaultCategory(routeTo.query.serviceCategory),
              types: ['cosmetic']
            }),
          ]);

          routeTo.params.serviceList = currentService.items;

          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
    props: (route) => ({
      serviceList: route.params.serviceList || []
    }),
  },
  // ===
  // 使用細則＆隱私權條款
  // ===
  {
    path: '/privacy',
    name: 'privacy',
    component: () => lazyLoadView(import('@views/Privacy/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
  // ===
  // 收不到簡訊驗證碼？(一次性密碼OTP)怎麼辦
  // ===
  {
    path: '/newsletter-tip',
    name: 'newsletter-tip',
    component: () => lazyLoadView(import('@views/NewsletterTip/Index.Jtails')),
    meta: {
      async beforeResolve(routeTo, routeFrom, next) {
        try {
          next()
        } catch (error) {
          routeError(error, routeTo, next({ name: '404' }), next);
        }
      },
    },
  },
]
